var map = {
	"./avatar_dani": 155,
	"./avatar_dani.jpg": 155,
	"./favicon/android-chrome-192x192": 156,
	"./favicon/android-chrome-192x192.png": 156,
	"./favicon/android-chrome-512x512": 157,
	"./favicon/android-chrome-512x512.png": 157,
	"./favicon/apple-touch-icon": 158,
	"./favicon/apple-touch-icon.png": 158,
	"./favicon/favicon-16x16": 159,
	"./favicon/favicon-16x16.png": 159,
	"./favicon/favicon-32x32": 160,
	"./favicon/favicon-32x32.png": 160,
	"./favicon/favicon.ico": 180,
	"./favicon/mstile-150x150": 161,
	"./favicon/mstile-150x150.png": 161,
	"./favicon/safari-pinned-tab": 162,
	"./favicon/safari-pinned-tab.svg": 162,
	"./favicon_master": 163,
	"./favicon_master.png": 163,
	"./hero_image": 164,
	"./hero_image.jpg": 164,
	"./home/en/preview-1": 4,
	"./home/en/preview-1.jpg": 4,
	"./home/en/preview-2": 5,
	"./home/en/preview-2.jpg": 5,
	"./home/en/preview-3": 6,
	"./home/en/preview-3.jpg": 6,
	"./home/en/preview-4": 7,
	"./home/en/preview-4.jpg": 7,
	"./home/en/preview-5": 8,
	"./home/en/preview-5.jpg": 8,
	"./home/en/preview-6": 9,
	"./home/en/preview-6.jpg": 9,
	"./home/en/preview-7": 10,
	"./home/en/preview-7.jpg": 10,
	"./home/nl/preview-1": 11,
	"./home/nl/preview-1.jpg": 11,
	"./home/nl/preview-2": 12,
	"./home/nl/preview-2.jpg": 12,
	"./home/nl/preview-3": 13,
	"./home/nl/preview-3.jpg": 13,
	"./home/nl/preview-4": 14,
	"./home/nl/preview-4.jpg": 14,
	"./home/nl/preview-5": 15,
	"./home/nl/preview-5.jpg": 15,
	"./home/nl/preview-6": 16,
	"./home/nl/preview-6.jpg": 16,
	"./home/nl/preview-7": 17,
	"./home/nl/preview-7.jpg": 17,
	"./icons/icon_192": 165,
	"./icons/icon_192.png": 165,
	"./icons/icon_512": 166,
	"./icons/icon_512.png": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;